'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'
import { Image } from '@/shared/ui'

type Props = {
  wide?: boolean
  className?: string
}

export const Layout = ({
  children,
  wide = false,
  className,
}: PropsWithChildren<Props>) => {
  const pathname = usePathname()

  const isHostMode = !!pathname?.startsWith('/host')
  const href = isHostMode ? '/host/main' : '/guest/main'

  return (
    <header
      className={cn(
        'flex h-[72px] w-fit min-w-full border-b border-gray-100 bg-white py-4',
        className,
      )}
    >
      <div className={cn('mx-auto flex w-fit grow')}>
        <div
          className={cn(
            'relative mx-6 flex h-10 w-full min-w-[1080px] items-center justify-between',
            wide && 'min-w-[1280px]',
          )}
        >
          <h1>
            <Link href={href} className="block w-fit">
              <Image
                src="/image/logo_pc.png"
                alt="33m2"
                width={62}
                height={30}
                external={false}
                priority
                unoptimized
              />
            </Link>
          </h1>
          {children}
        </div>
      </div>
    </header>
  )
}
